import React from "react";
import {Field} from "react-final-form";

function RadioFields({name, options, className, parse}) {
    return (
        <div className="choose-items">
            {options.map(option => (
                <Field
                    key={option.value}
                    name={name}
                    type="radio"
                    value={option.value}
                    disabled={option.disabled}
                    parse={parse}
                >
                    {({ input }) => (
                        <label
                            className={`${className || 'checkbox'} ${
                                input.checked ? 'selected' : ''
                            }`}
                        >
                            <input {...input} type="radio" disabled={option.disabled} />
                            <span className="checkmark">
                                <img src="/_core/assets/themes/v5/assets/img/form3/ok-icon.svg" alt="" />
                            </span>
                            <span>{option.label}</span>
                        </label>
                    )}
                </Field>
            ))}
        </div>
    );
}

export default RadioFields;
